type BillingBusinessProps = {
	id?: string;
	name?: string;
	companyNumber?: string;
	taxIdentifier?: string;
};

class BillingBusiness {
	constructor(public _: BillingBusinessProps) {}

	static fromJson(json: any) {
		return new BillingBusiness({
			id: json.id,
			name: json.name,
			companyNumber: json.company_number,
			taxIdentifier: json.tax_identifier,
		});
	}

	toJson() {
		const res = {
			id: this._.id,
			name: this._.name,
			company_number: this._.companyNumber,
			tax_identifier: this._.taxIdentifier,
		} as any;
		return res;
	}

	get displayText() {
		let string = this._.name ?? "";
		if (this._.companyNumber) {
			string += ` (${this._.companyNumber})`;
		}
		if (this._.taxIdentifier) {
			string += ` - ${this._.taxIdentifier}`;
		}
		return string;
	}

	copyWith(props: Partial<BillingBusinessProps>) {
		return new BillingBusiness({ ...this._, ...props });
	}
}

export { BillingBusiness };
